import { alertItemStyles } from './AlertItem.styles.ts'
import type { AlertItemProps } from './AlertItem.types.ts'

const TYPE_ICONS: Record<string, string> = {
  success: '\u2713',
  error: '\u2717',
  warning: '\u26A0',
  info: '\u2139',
  debug: '\u2699',
}

export function AlertItem({ alert, onDismiss }: AlertItemProps) {
  return (
    <div
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      style={alertItemStyles.container(alert.type)}
    >
      <span aria-hidden="true" style={{ marginRight: 'var(--space-sm)' }}>
        {TYPE_ICONS[alert.type]}
      </span>
      <span style={alertItemStyles.message}>{alert.message}</span>
      {alert.dismissible !== false && (
        <button
          type="button"
          onClick={() => onDismiss(alert.id)}
          style={alertItemStyles.closeButton}
          aria-label="Dismiss alert"
        >
          &times;
        </button>
      )}
    </div>
  )
}
